import moment from 'moment'
import { isRTL } from 'src/common/rtl/rtlTransform'

const loadLocaleData = async (locale) => {
  await require(`@formatjs/intl-pluralrules/locale-data/${toLanguageCode(locale)}`) // Add locale data
  await require(`@formatjs/intl-relativetimeformat/dist/locale-data/${toLanguageCode(locale)}`) // Add locale data

  // There is some problem with RTL language support in Scheduler -> react-dates DayPickerSingleDateController
  // Also, string formatting to standard is problematic with these RTL numbers
  // Therefore for now leave moment as default for RTL locales
  if (!isRTL(locale)) {
    // Try to import with or without region code since moment may have one of the versions.
    await Promise.resolve()
      .then(() => require(`moment/locale/${locale}`))
      .catch(() => require(`moment/locale/${toLanguageCode(locale)}`))
      .catch(() => {})

    moment.locale(locale)
  }
}

function toLanguageCode(lcid) {
  return lcid.split(/[-_]/)[0]
}

export default loadLocaleData
